import UserModel, { userUrn } from '@/models/entities/UserModel';
import { USER_STATUS } from '@/models/references/references';
import { resolveReference } from '@/stores/useReferenceOptions';
import UserStatusHistoryModel from '@/models/services/UserStatusHistoryModel';

/** Active ou désactive un user (POST /user_status_histories) ; retourne le message à afficher */
export async function toggleUserStatus(user: UserModel): Promise<string> {
  await new UserStatusHistoryModel().save(
    {
      user: userUrn(user.id),
      userStatus: (await resolveReference('userStatuses', user.isEnabled ? USER_STATUS.DISABLED : USER_STATUS.ENABLED))
        .urn,
    },
    { silentError: true },
  );

  return user.isEnabled ? `${user.fullName} est désactivé.` : `${user.fullName} est réactivé.`;
}

/**
 * Pourquoi le statut (ou la suppression) d'un user n'est pas modifiable à la main, null s'il l'est. iamManaged : lié à
 * au moins une identité IAM (Okta / Entra), son statut est piloté par l'IAM (l'API le refuse de même)
 */
export function getManualChangeBlocker(iamManaged: boolean, isMe: boolean, action: 'status' | 'delete'): string | null {
  if (iamManaged) return 'Géré par son IAM (Okta / Entra)';
  if (isMe)
    return action === 'status'
      ? 'Vous ne pouvez pas vous désactiver vous-même'
      : 'Vous ne pouvez pas supprimer votre propre compte';
  return null;
}
